export default __webpack_public_path__ + "static/tek_dubai_ae-6ee96df320aeee4ed5f6092a8b2877be.png";